import { render, staticRenderFns } from "./MenuScreen.vue?vue&type=template&id=7bb65aa8"
import script from "./MenuScreen.vue?vue&type=script&lang=js"
export * from "./MenuScreen.vue?vue&type=script&lang=js"
import style0 from "./MenuScreen.vue?vue&type=style&index=0&id=7bb65aa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports